/* eslint-disable import/no-cycle */
import * as React from 'react'
import StoryblokService from 'utils/storyblok-service'
import { media } from 'utils/transforms'
import DialogTrailComponent from './DialogTrail'

export const transformProps = (propsArg) => {
  const props = { ...propsArg }

  if (props.backgroundMedia && props.backgroundMedia.filename) {
    props.backgroundMediaProps = media(props.backgroundMedia)

    delete props.backgroundMedia
  }

  if (props.backgroundMediaMobile && props.backgroundMediaMobile.filename) {
    props.backgroundMediaMobile = media(props.backgroundMediaMobile)
  }

  if (props.description) {
    props.description = StoryblokService?.client?.richTextResolver?.render(props.description)
  }

  return props
}

const DialogTrail = (props) => <DialogTrailComponent {...transformProps(props)} />

export default DialogTrail
